import { useParams } from 'next/navigation'
import { useTaskToolContext } from '@/app/providers/task-tool-context/task-tool-context-provider'

export default function useGetTaskIdWithContext() {
  const context = useTaskToolContext()
  const params = useParams<{ taskId: string; taskToolId: string }>()

  if (context) {
    return { taskId: context.taskId, toolId: context.toolId }
  }
  return { taskId: params?.taskId || '', toolId: params?.taskToolId || '' }
}
